var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tracking"},[_c('main-menu'),_c('h1',{staticClass:"notice"},[_vm._v("Tracking")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }